module.exports = __webpack_public_path__ + "static/media/page3-sheep.df37fed4.png";